import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { transformSDKFieldMaskToRESTFieldMask } from '@wix/sdk-runtime/transformations/field-mask';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveComWixpressRestaurantsOrdersettingsV3OrderSettingsApiUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'www.wixapis.com': [
      {
        srcPath: '/restaurants/v3/order-settings',
        destPath: '/v3/order-settings',
      },
    ],
    _: [
      {
        srcPath: '/_api/order-settings',
        destPath: '/v3/order-settings',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_api/order-settings',
        destPath: '/v3/order-settings',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/_api/order-settings',
        destPath: '/v3/order-settings',
      },
    ],
    'api._api_base_domain_': [
      {
        srcPath: '/restaurants/v3/order-settings',
        destPath: '/v3/order-settings',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_restaurants_order-settings';

/** Get a OrderSettings by id */
export function getOrderSettings(payload: object): RequestOptionsFactory<any> {
  function __getOrderSettings({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.ordersettings.v3.order_settings',
      method: 'GET' as any,
      methodFqn:
        'com.wixpress.restaurants.ordersettings.v3.OrderSettingsApi.GetOrderSettings',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsOrdersettingsV3OrderSettingsApiUrl({
        protoPath: '/v3/order-settings/{orderSettingsId}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __getOrderSettings;
}

/** Update a OrderSettings, supports partial update */
export function updateOrderSettings(
  payload: object
): RequestOptionsFactory<any> {
  function __updateOrderSettings({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFieldMaskToRESTFieldMask,
        paths: [{ path: 'mask' }],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.restaurants.ordersettings.v3.order_settings',
      method: 'PATCH' as any,
      methodFqn:
        'com.wixpress.restaurants.ordersettings.v3.OrderSettingsApi.UpdateOrderSettings',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsOrdersettingsV3OrderSettingsApiUrl({
        protoPath: '/v3/order-settings/{orderSettings.id}',
        data: serializedData,
        host,
      }),
      data: serializedData,
    };

    return metadata;
  }

  return __updateOrderSettings;
}

/** List Order settings */
export function listOrderSettings(payload: object): RequestOptionsFactory<any> {
  function __listOrderSettings({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.ordersettings.v3.order_settings',
      method: 'GET' as any,
      methodFqn:
        'com.wixpress.restaurants.ordersettings.v3.OrderSettingsApi.ListOrderSettings',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsOrdersettingsV3OrderSettingsApiUrl({
        protoPath: '/v3/order-settings',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __listOrderSettings;
}
